<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          Event Categories
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addingNewItem">Add New
            Category</vs-button>
        </h3>
        <!-- <p class="card-subtitle">List of Default Categories to System.</p> -->
        <vs-row>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Language Filter" v-model="search.language" @change="searchData()">
              <!-- <vs-select-item value="all" text="All Languages" /> -->
              <vs-select-item :key="index" :value="item.culture" :text="item.culture"
                v-for="(item, index) in languages" />
            </vs-select>
          </vs-col>
          <!-- <vs-col vs-lg="3" vs-xs="12">
              <vs-select
                :color="colorx"
                label="Sorting Type"
                v-model="search.sort"
              >
                <vs-select-item value text="Select Sorting" disabled />
                <vs-select-item value="ASC" text="Ascending" />
                <vs-select-item value="DESC" text="Descending" />
              </vs-select>
            </vs-col> -->
          <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Status Filter" v-model="search.status" @change="searchData()">
              <vs-select-item value text="Select Status" disabled />
              <vs-select-item value="0" text="All" />
              <vs-select-item value="1" text="Active" />
              <vs-select-item value="2" text="Inactive" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12">
            <!-- <vs-button
                color="primary"
                type="filled"
                class="searchBtn"
                @click="searchData()"
                icon="search"
                >Search</vs-button
              > -->
            <vs-button color="warning" type="filled" class="searchBtn" icon="cached"
              @click="resetData()">Reset</vs-button>
          </vs-col>
        </vs-row>
        <br />
        <table class="table">
          <tr>
            <th>#</th>
            <th></th>
            <th>Category Name</th>
            <th>Short Name</th>
            <th>Language</th>
            <th>Status</th>
            <!-- <th>Guid</th> -->
            <th></th>
          </tr>
          <tr v-for="(item, index) in all" :key="item.categoryName">
            <td>{{ index + 1 }}</td>
            <td>
              <img v-if="item.image == '' || item.image == null" src="../../../assets/images/No-image.png" height="50px"
                width="75px" />
              <img v-else :src="item.image" height="50px" width="75px" />
            </td>
            <td class="td">{{ item.categoryName }}</td>
            <td class="td">{{ item.shortName }}</td>
            <td class="td">{{ item.language }}</td>
            <td class="td">
              <vs-chip v-if="item.status" color="success">Active</vs-chip>
              <vs-chip v-else color="danger">Inactive</vs-chip>
            </td>
            <!-- <td class="td">{{ item.guid }}</td> -->
            <td class="td">
              <vs-button class="mr15 mt-1" icon="create" size="small" color="warning"
                @click="editingItem(item, 'edit')">Edit</vs-button>
              <vs-button class="mr15 mt-1" size="small" color="danger" icon="delete_sweep" @click="
                deleteCategoryPopup = true;
              itemToDelete = item;
              ">
                Delete
              </vs-button>
              <!-- <vs-button
                  class="mr15 mt-1"
                  size="small"
                  color="success"
                  @click="editingItem(item, 'clone')"
                  >Duplicate</vs-button> -->
            </td>
          </tr>
        </table>

        <!-- Code -->
        <vs-popup :title="isNew
          ? 'Add New Category'
          : clone
            ? 'Duplicate Category'
            : 'Edit Category'
          " :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Category Name (Keep it Simple and short)" v-model="cat.categoryName" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Category Short Name " v-model="cat.shortName" />
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-select :color="colorx" label="Category Language" v-model="cat.language" icon="arrow_downward">
                <vs-select-item value text="Choose Language" disabled />
                <vs-select-item :value="item.culture" :text="item.culture" v-for="(item, index) in languages"
                  :key="index" />
              </vs-select>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-4">
              <vs-checkbox v-model="cat.status">Status (Active / Inactive)</vs-checkbox>
            </vs-col>
            <!-- <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
                <uploader
                  label="Category File (Try to use square image)"
                  v-model="cat.image"
                  :file="cat.image"
                />
              </vs-col> -->
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" v-if="displayImage == ''">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Category File (Try to use square image)</label>
                    <div class="btn">
                      <vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File
                    </div>
                    <input type="file" ref="fileInput" @change="uploadImage($event)" />
                  </div>
                </vs-col>
                <vs-col v-if="displayImage">
                  <vs-button color="danger" type="flat" icon="clear" class="closeBtn"
                    @click="deleteImage()"></vs-button>
                  <img :src="displayImage" class="imgUp" height="100px" width="150px" />
                  <b v-if="fileName">File Name : {{ fileName }}</b>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-button icon="save" @click="btnAddCategory">Save</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>

        <vs-popup class="holamundo" title="Delete Category" :active.sync="deleteCategoryPopup">
          <p>Are you sure you want to delete Category?</p>
          <div>
            <vs-button icon="delete_forever" class="mr15" @click="deleteCategory">Delete Category</vs-button>
            <vs-button icon="clear" @click="deleteCategoryPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>
        <!-- Code -->
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
// import uploader from "../common/uploader.vue";
import api from "@/rest.js";
import { API } from "@/common/constants";

export default {
  name: "Category",
  components: {
    // uploader,
  },
  data: () => ({
    title: "Category",
    colorx: "#0D2144",
    defaultalert: false,
    deleteCategoryPopup: false,
    isNew: true,
    clone: false,
    displayImage: "",
    fileName: "",
    search: {
      sort: "ASC",
      language: "EN",
      status: "0",
    },
    cat: {
      status: true,
      language: "",
      shortName: "",
      categoryName: "",
      image: "",
    },
    itemToDelete: "",
    itemToUpdate: "",
    all: [],
    languages: [],
  }),
  methods: {
    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.cat = {
        status: true,
        language: "",
        shortName: "",
        categoryName: "",
        image: "",
      };
      this.$data.displayImage = "";
    },
    editingItem(i, data) {
      this.$data.cat = Object.assign({}, i);
      this.$data.defaultalert = true;
      this.$data.isNew = false;
      this.$data.displayImage = i.image;
      this.$data.clone = data == "clone" ? true : false;
    },
    btnAddCategory() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      let apiToCall = API.INSERT_EVENT_CAT;
      let data = this.$data.cat;
      this.$data.cat.image = this.$data.displayImage;

      if (!this.$data.isNew) {
        apiToCall = API.UPDATE_EVENT_CAT;
        data["image"] = this.$data.displayImage;
      }
      if (!this.$data.isNew && !this.$data.clone) {
        this.$data.displayImage = "";
      }
      if (this.$data.clone) {
        apiToCall = API.INSERT_EVENT_CAT;

        data = {
          categoryName: this.$data.cat.categoryName,
          shortName: this.$data.cat.shortName,
          // count: this.$data.cat.count,
          language: this.$data.cat.language,
          status: this.$data.cat.status,
          image: this.$data.cat.image,
        };
      }

      if (
        !data.categoryName ||
        !data.shortName ||
        !data.language ||
        data.language === "all" ||
        !data.image
      ) {
        this.$vs.notify({
          title: "Error",
          text: "Please enter all the fields",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      this.$vs.loading();
      if (!this.$data.isNew) {
        api
          .put(apiToCall + "?id=" + data._id, data, { headers })
          .then((r) => {
            this.$vs.loading.close();

            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            (this.$data.cat = {
              status: true,
              language: "",
              shortName: "",
              categoryName: "",
              image: "",
            }),
              this.searchData()
          })
          .catch((error) => {
            console.log(error);
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: error.response.data.error,
              color: "danger",
              position: "top-right",
            });
          });
        return;
      }
      api
        .post(apiToCall, data, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.data.status) {
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            (this.$data.cat = {
              status: true,
              language: "",
              shortName: "",
              categoryName: "",
              image: "",
            }),
              this.searchData()
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.response.data.error,
            color: "danger",
            position: "top-right",
          });
        });
    },
    fetchAllCategory() {
      this.$vs.loading();
      api
        .get(`${API.GET_EVENT_CAT}?language=${this.$data.search.language}`, {})
        .then((r) => {
          console.log(r);
          this.$vs.loading.close();
          this.$data.all = r.data;
          // if (!r.data.status) {
          //   this.$vs.notify({
          //     title: "Error",
          //     text: r.data.error,
          //     color: "danger",
          //     position: "top-right",
          //   });
          // }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteCategory() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .delete(
          API.DELETE_EVENT_CAT + "?id=" + this.$data.itemToDelete._id,
          {},
          { headers }
        )
        .then((r) => {
          if (r.data.status) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.deleteCategoryPopup = false;
          this.searchData()
        })
        .catch(() => { });
    },
    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data
        })
        .catch(() => { });
    },
    searchData() {
      // if (this.$data.search.language == "all") {
      //   this.fetchAllCategory();
      //   return;
      // }
      this.$vs.loading();
      api
        .get(`${API.SEARCH_EVENT_CAT}?language=${this.$data.search.language}&status=${this.$data.search.status}`, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.all = r.data;
          // if (!r.data.status) {
          //   this.$vs.notify({
          //     title: "Error",
          //     text: r.data.error,
          //     color: "danger",
          //     position: "top-right",
          //   });
          // }
        })
        .catch(() => { });

      // this.$router.push(
      //   "/category/" +
      //     this.$data.search.categoryGuid +
      //     "?catLang=" +
      //     this.$data.search.language
      // );
    },
    uploadImage(data) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      this.$data.fileName = data.target.files[0].name;
      formdata.append("category", this.$data.cat.categoryName);
      formdata.append("file", data.target.files[0]);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            this.$data.displayImage = response.data.files[0].url;
            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => { });
      this.$vs.loading.close();
    },
    deleteImage() {
      this.$data.displayImage = "";
    },
    resetData() {
      this.$data.search = {
        sort: "ASC",
        language: "EN",
        status: "0",
      };
      this.fetchAllCategory();
    },
  },
  created() {
    if (this.$data.search.language) {
      this.$data.search.language = this.$route.query.catLang;
    }
    if (!this.$data.search.language) {
      this.$data.search.language = "EN";
    }
    this.$route.query.catLang ? this.searchData() : this.fetchAllCategory();
    this.fetchAllLanguages();
  },
};
</script>
<style scoped>
.mb15 {
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
}

.mt20 {
  margin-top: 20px;
}

.searchBtn {
  margin-top: 25px;
  margin-right: 5px;
  width: 30%;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>